// Import des styles SCSS
import '../scss/main.scss';

document.addEventListener('DOMContentLoaded', () => {
  document.getElementsByTagName('body')[0].classList.add('lemji-theme');
});

// Class principale du thème
class MonTheme {
  constructor() {
    this.initSmoothScroll();
    this.initDelegateLink();
  }

  // Défilement fluide pour les ancres
  initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        const targetId = this.getAttribute('href');
        if (targetId === '#') return;

        const targetElement = document.querySelector(targetId);
        if (targetElement) {
          e.preventDefault();
          window.scrollTo({
            top: targetElement.offsetTop,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  // Délégation des liens - rendre tout un bloc cliquable
  initDelegateLink() {
    // Sélectionner tous les éléments avec la classe delegate-link
    const delegateBlocks = document.querySelectorAll('.delegate-link');

    delegateBlocks.forEach(block => {
      // Chercher le premier lien ou bouton dans le bloc (qui n'a pas la classe no-delegate)
      const targetLink = block.querySelector('a:not(.no-delegate), button[onclick]:not(.no-delegate), button[data-href]:not(.no-delegate)');

      if (targetLink) {
        // Masquer visuellement le bouton/lien original
        targetLink.style.position = 'absolute';
        targetLink.style.left = '-9999px';
        targetLink.style.opacity = '0';
        targetLink.style.pointerEvents = 'none';

        // Ajouter un style visuel pour indiquer que le bloc est cliquable
        block.style.cursor = 'pointer';

        // Déléguer le clic vers le lien/bouton original
        block.addEventListener('click', (e) => {
          // Éviter la double exécution si on clique sur le lien original ou un élément avec no-delegate
          if (e.target === targetLink || e.target.closest('.no-delegate')) return;

          // Éviter de déclencher si on clique sur un autre lien/bouton dans le bloc
          if (e.target.tagName === 'A' || e.target.tagName === 'BUTTON') return;

          // Gérer les différents types de liens/boutons
          if (targetLink.tagName === 'A') {
            // Pour les liens normaux
            if (targetLink.href) {
              if (targetLink.target === '_blank') {
                window.open(targetLink.href, '_blank', 'noopener,noreferrer');
              } else {
                window.location.href = targetLink.href;
              }
            }
          } else if (targetLink.tagName === 'BUTTON') {
            // Pour les boutons avec onclick
            if (targetLink.onclick) {
              targetLink.onclick.call(targetLink, e);
            }
            // Pour les boutons avec data-href
            else if (targetLink.dataset.href) {
              window.location.href = targetLink.dataset.href;
            }
            // Déclencher un clic sur le bouton original
            else {
              targetLink.click();
            }
          }
        });

        // Améliorer l'accessibilité
        if (!block.getAttribute('role')) {
          block.setAttribute('role', 'button');
        }
        if (!block.getAttribute('tabindex')) {
          block.setAttribute('tabindex', '0');
        }

        // Ajouter un attribut aria-label si pas déjà présent
        if (!block.getAttribute('aria-label')) {
          const title = block.querySelector('h1, h2, h3, h4, h5, h6');
          if (title) {
            block.setAttribute('aria-label', `Cliquer pour accéder à : ${title.textContent.trim()}`);
          }
        }

        // Gérer la navigation au clavier
        block.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            block.click();
          }
        });

        // Ajouter une classe pour indiquer que la délégation est active
        block.classList.add('delegate-link--active');
      }
    });
  }
}

// Initialiser le thème une fois que le DOM est chargé
document.addEventListener('DOMContentLoaded', () => {
  new MonTheme();
});

// Exportation pour webpack
export default MonTheme;
